import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useBrandGuidelines } from "@modules/ECMS/CORPORATE/Forms/MediaCentre/Media.hook";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { fields } from "../constants";

export const BrandingGuidelinesNextPage = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const { data: cameraData, error, isLoading, isError, refetch: useRefetchBrand } = useBrandGuidelines();
  const {
    data: cameraDataById,
    isLoading: isLoadingCam,
    refetch: refetchBrand,
  } = useDocumentDetails(query?.get("id") || "");

  console.log("brandGuidelines", cameraData, cameraDataById);

  useEffect(() => {
    if (!query.get("id")) {
      useRefetchBrand();
    }
  }, []);

  useEffect(() => {
    if (query.get("id")) {
      refetchBrand();
    }
  }, [query.get("id")]);

  const MediaFormConfig: FormConfig = {
    initialValues: {
      field_content_english_markup: cameraDataById?.payload
        ? decodeHTML(JSON.parse(cameraDataById?.payload?.field_content_english)?.data?.markup)
        : decodeHTML(cameraData?.[0]?.field_content_english?.data?.markup),

      field_content_english_name: cameraDataById?.payload
        ? decodeHTML(JSON.parse(cameraDataById?.payload?.field_content_english)?.data?.nextPage?.name)
        : decodeHTML(cameraData?.[0]?.field_content_english?.data?.nextPage?.name),

      field_content_english_link: cameraDataById?.payload
        ? decodeHTML(JSON.parse(cameraDataById?.payload?.field_content_english)?.data?.nextPage?.link)
        : decodeHTML(cameraData?.[0]?.field_content_english?.data?.nextPage?.link),

      field_content_ms_markup: cameraDataById?.payload
        ? decodeHTML(JSON.parse(cameraDataById?.payload?.field_content_malay)?.data?.markup)
        : decodeHTML(cameraData?.[0]?.field_content_malay?.data?.markup),

      field_content_ms_name: cameraDataById?.payload
        ? decodeHTML(JSON.parse(cameraDataById?.payload?.field_content_malay)?.data?.nextPage?.name)
        : decodeHTML(cameraData?.[0]?.field_content_malay?.data?.nextPage?.name),

      field_content_ms_link: cameraDataById?.payload
        ? decodeHTML(JSON.parse(cameraDataById?.payload?.field_content_malay)?.data?.nextPage?.link)
        : decodeHTML(cameraData?.[0]?.field_content_malay?.data?.nextPage?.link),

      field_content_zh_markup: cameraDataById?.payload
        ? decodeHTML(JSON.parse(cameraDataById?.payload?.field_content_mandarin)?.data?.markup)
        : decodeHTML(cameraData?.[0]?.field_content_mandarin?.data?.markup),

      field_content_zh_name: cameraDataById?.payload
        ? decodeHTML(JSON.parse(cameraDataById?.payload?.field_content_mandarin)?.data?.nextPage?.name)
        : decodeHTML(cameraData?.[0]?.field_content_mandarin?.data?.nextPage?.name),

      field_content_zh_link: cameraDataById?.payload
        ? decodeHTML(JSON.parse(cameraDataById?.payload?.field_content_mandarin)?.data?.nextPage?.link)
        : decodeHTML(cameraData?.[0]?.field_content_mandarin?.data?.nextPage?.link),
    },
    fields: fields.brandingGuidelinesNextPage,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let excludedKeys: any = [];
    let imageKeys: any = [
      "fbImage",
      "field_purchase_login_pop_image",
      "field_login_image",
      "filledImage",
      "googleImage",
      "showImage",
      "field_logout_image",
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CORPORATE");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    const payload = {
      action: action,
      method: method,
      module: "Media Center",
      subModule: `${query?.get("activeTab")}_${query.get("subActiveTab")}`,
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      moduleKey: "MAHB_CORPORATE_Media Center_Branding Guidelines",
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        id: data?.id || cameraData?.[0]?.id || cameraDataById?.payload?.id,
        field_content_english: JSON.stringify({
          data: {
            markup: data?.field_content_english_markup ?? "",
            nextPage: {
              name: data?.field_content_english_name ?? "",
              link: data?.field_content_english_link ?? "",
            },
          },
        }),
        field_content_malay: JSON.stringify({
          data: {
            markup: data?.field_content_ms_markup ?? "",
            nextPage: {
              name: data?.field_content_ms_name ?? "",
              link: data?.field_content_ms_link ?? "",
            },
          },
        }),
        field_content_mandarin: JSON.stringify({
          data: {
            markup: data?.field_content_zh_markup ?? "",
            nextPage: {
              name: data?.field_content_zh_name ?? "",
              link: data?.field_content_zh_link ?? "",
            },
          },
        }),
        field_page: cameraData?.[0]?.field_page || cameraDataById?.payload?.field_page || "",
        published: true,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <>
      <DynamicForm
        isLoading={isLoading || isLoadingCam}
        config={MediaFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${corporateHost}/api/page-content/${cameraData?.[0]?.id || cameraDataById?.payload?.id}`,
            "UPDATE",
            "PATCH",
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Media Center"
      />
    </>
  );
};
